// @flow

import { observer } from "mobx-react";
import React from "react";

import ConfirmationModal from "app/components/ConfirmationModal/ConfirmationModal";

import "./VideoDelete.scss";

type Props = {
    onDelete: Function
};

type State = {
    deleting: boolean
};

@observer
export default class VideoDelete extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { deleting: false };
    }

    handleClick() {
        this.setState({ deleting: true });
    }

    handleCancel() {
        this.setState({ deleting: false });
    }

    handleDelete() {
        this.props.onDelete().then(() => {
            window.location.href = "/dashboard";
        });
    }

    render() {
        return (
            <div className="VideoDelete">
                <button
                    type="button"
                    className="VideoDelete__button"
                    onClick={this.handleClick.bind(this)}
                >
                    <i className="fa fa-trash" /> Delete Video
                </button>

                {this.renderDeleteConfirmation()}
            </div>
        );
    }

    renderDeleteConfirmation() {
        if (!this.state.deleting) return null;

        return (
            <ConfirmationModal
                message="Are you sure you want to delete the video?"
                cancelText="No"
                actionText="Yes, delete it"
                onConfirm={this.handleDelete.bind(this)}
                onCancel={this.handleCancel.bind(this)}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/VideoDelete/VideoDelete.js